import { render } from "./IndicatorChart.vue?vue&type=template&id=10358a21"
import script from "./IndicatorChart.vue?vue&type=script&lang=js"
export * from "./IndicatorChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__